export const LABELS = {
  email: "Email",
  feeAmount: "Broker fee",
  firmName: "Broker firm name",
  name: "Broker name",
  phoneNumber: "Phone number",
  brokerFeeAddedToLoan: "Broker fee added to the loan?",
  lenderFeeAddedToLoan: "Lender fee added to the loan?",
};
